import { SmartphoneNfc } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { fmtDate } from "../lib/format";
import { NoticeShell } from "./NoticeShell";

export function DeviceAlertNotice() {
  const [d, setD] = useState<any>(null);
  useEffect(() => { api.get("/admin/device-alerts").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d || !d.count) return null;
  const to = "/monitoring-mobile";
  return (
    <NoticeShell id="device-alert-notice" tone="red" to={to} icon={<SmartphoneNfc className="h-5 w-5" />}
      title={<p>HP siswa berhenti menerima notifikasi &gt; 3 hari · {d.count} siswa</p>}
      action={<Link to={to} className="font-semibold text-red-700 dark:text-red-300 hover:underline" data-testid="device-alert-notice-link">Tindak lanjuti →</Link>}>
      <p className="text-xs text-red-700/80 dark:text-red-300/80 mt-0.5">Kemungkinan aplikasi dihapus atau izin notifikasi dicabut — melanggar ketentuan. Hubungi siswa dan minta pasang ulang; reminder sementara hanya via email.</p>
      <ul className="mt-2 flex flex-wrap gap-1.5" onClick={(e) => e.stopPropagation()}>
        {d.items.slice(0, 10).map((it: any) => (
          <li key={it.student_id}>
            <Link to={it.loan_id ? `/pinjaman/${it.loan_id}` : "/siswa"} className="inline-flex items-center gap-1 rounded-full bg-white/80 dark:bg-white/10 border border-red-200 dark:border-red-800 px-2.5 py-0.5 text-xs hover:bg-white" data-testid={`device-alert-item-${it.internal_id}`}>
              <span className="font-semibold">{it.name}</span><span className="text-muted-foreground num">· {it.internal_id} · {it.reason} sejak {it.since ? fmtDate(it.since.slice(0, 10)) : "-"}</span>
            </Link>
          </li>
        ))}
        {d.count > 10 && <li className="text-xs text-muted-foreground self-center">+{d.count - 10} lainnya</li>}
      </ul>
    </NoticeShell>
  );
}
